"use strict";

var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/element-resize-detector/~/batch-processor/src/utils.js
 ** module id = 62
 ** module chunks = 0
 **/